module.exports = __webpack_public_path__ + "static/media/spain.a62a83f3.svg";